import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  var splide = new Splide(".splide", {
    type: "fade",
    isNavigation: true,
    slideFocus: true,
    rewind: true,
    paginationDirection: "ttb",
    breakpoints: {
      960: {
        paginationDirection: "ltr",
      }
    }
  });
  // splide.on("resize", function () {
  //   if (window.innerWidth <= 960) {
  //     console.log("smaller");
  //   } else {
  //     console.log("larger");
  //   }
  // });

  splide.on("pagination:mounted", function (data) {
    // You can add your class to the UL element
    data.list.classList.add("splide__pagination--custom");
  });

  let slideTypeOne = document.querySelector(".splide__slide.type-1");
  const splideSlider = document.querySelector(".splide");

  splide.on("active", function () {
  
    if (slideTypeOne.classList.contains("is-active")) {
      splideSlider.classList.add("slide-with-credentials");
    } else {
      splideSlider.classList.remove("slide-with-credentials");
    }
  });

  splide.mount();
});
